import { css } from '@emotion/react';
export const getGlobalStyles = (theme) => css `
  html,
  body {
    background-color: ${theme.colors.surface?.defaultAlt};
    color: ${theme.colors.text?.basic.primary};
    height: 100vh;
    width: 100vw;
    margin: 0;
    padding: 0;
  }

  html.theme-light,
  html:not(.theme-dark) {
    scrollbar-color: #00000069 ${theme.colors.surface?.defaultAlt};
  }

  html.theme-dark {
    scrollbar-color: #ffffff69 ${theme.colors.surface?.defaultAlt};
  }

  body {
    font-family: ${theme.fonts.main};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;
//# sourceMappingURL=global.styles.js.map